import { httpClient } from './httpClient';
import { CasesApiResponse } from '@packages/global';

const BASE_URL = '';

export const caseApi = {
  /**
   * 获取案例列表（公开）
   * @param lang 语言版本 'zh' | 'en'
   */
  getCases: async (lang: 'zh' | 'en' = 'zh'): Promise<CasesApiResponse> => {
    return httpClient.get<CasesApiResponse>(`${BASE_URL}/cases?lang=${lang}`);
  },
};
